<!--
 * @Author: your name
 * @Date: 2021-09-15 11:40:44
 * @LastEditTime: 2023-01-21 10:10:07
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/zhejiangconsume/index.vue
-->
<template>
  <div ref="box" id="macau">
    <div id="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-au-1-1.jpg"
        alt=""
      />
    </div>
    <div class="content">
      <div class="boxList">
        <videoComp
          src="https://source.qunarzz.com/site/images/wns/20230112-shijianchen-video-006.mp4"
          poster="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-ao-poster.jpeg"
        ></videoComp>
        <mt-swipe class="swipeWrapper" :auto="3000">
          <mt-swipe-item v-for="(item, index) in list" :key="index">
            <div class="img-box">
              <img @click="showDetail(item)" :src="item.img" alt="" />
              <div class="bolang">
                {{ item.txt }}
              </div>
            </div>
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="contentActive">
        <div class="box2331">
          <img
            src="https://source.qunarzz.com/site/images/wns/20230113-shijianchen-aomen-2.jpg"
            alt=""
          />
          <img
            class="discount"
            src="https://source.qunarzz.com/site/images/wns/20230101-shijianchen-au-a1.png"
            alt=""
          />
        </div>
        <div class="tabs">
          <div @click="toggle(0)" class="tab"></div>
          <div @click="toggle(1)" class="tab"></div>
          <div @click="toggle(2)" class="tab"></div>
        </div>
        <a
          href="https://s.nia.gov.cn/mps/bszy/wlgaot/sqgowl/201903/t20190313_1002.html"
          v-maidian="'step1'"
          id="step1"
          class="step1"
        ></a>
        <a
          href="https://m.flight.qunar.com/shark/active/d26b93a65f964d24cdd146bea4ed2ed0"
          v-maidian="'step2'"
          class="step2"
          id="step2"
        ></a>
        <!-- <a
          href="javascript:vold"
          @click="jumpTo"
          v-maidian="'step3'"
          class="step3"
        ></a> -->
        <div @click="jumpTo" class="step3">
          <!-- <gotomini></gotomini> -->
        </div>
      </div>
      <img
        src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-au-3.jpg"
        alt=""
      />
      <div id="step3">
        <div id="hot">
          <lineComp2 type="hot" :lineList="hotImg"></lineComp2>
          <div class="bottom">
            <img
              src="https://source.qunarzz.com/site/images/wns/20230110-shijianchen-au-6.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lineComp from './components/line.vue';
import lineComp2 from './components/line2.vue';
import ruleDialog from './components/rule/index';
import detailDialog from './components/detail/index';
import videoComp from './video.vue';
import $ from 'jquery';
import gotomini from './components/gotomini.vue';
export default {
  components: {
    lineComp: lineComp,
    lineComp2,
    gotomini,
    videoComp,
  },
  data() {
    return {
      current: 0,
      hotImg: [
        [
          {
            headImg:
              'https://tr-osdcp.qunarzz.com/tr-osd-tr-mapi/img/7e4b0309052e1753a2f82968a9c1a2de.jpg_r_300x300x95_a77fa373.jpg',
            dec: '夜晚漫步官也街，充满了浪漫的小魅力',
            desc: '夜晚的官也街充满了浪漫的小魅力，仿佛置身梦幻及古典瑰丽的童话世界',
            linkId:
              'https://touch.travel.qunar.com/h5/topic/comment/31972113?showType=share&bd_source=topic_comment',
          },
          {
            headImg:
              'https://tr-osdcp.qunarzz.com/tr-osd-tr-mapi/img/e39b2f2837590b0d208029111a4a4849.jpg_r_450x600_9f8b3650.jpg',
            dec: '开放自助签后再加上酒店5折券，赶紧安排上澳门之旅吧！',
            desc: '澳门四天三晚全攻略',
            linkId:
              'https://lang.qunar.com/site_node/mavericks/detailOld?gk=footPrint_6331922485451&sourceFrom=shareLong',
          },
          {
            headImg:
              'https://tr-osdcp.qunarzz.com/tr-osd-tr-mapi/img/632f29b8c8c25b39fcfd7b3e847dd109.jpg_450x360_9f68c836.jpg',
            dec: '澳门完整攻略',
            desc: '保姆级出行手册',
            linkId:
              'https://lang.qunar.com/site_node/mavericks/detailOld?gk=footPrint_6327815826211&sourceFrom=shareLong',
          },
        ],
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221109-shijianchen-img-3.jpg',
            dec: '澳门美食分享系列：超高性价比旋转西餐厅！本地人n刷~',
            desc: '想找一家气氛好、出品又高质的餐厅，但预算有限？这家性价比超高的旋转西餐厅「璇宫」就介绍得及时了',
            linkId:
              'https://touch.travel.qunar.com/youji/7735729?bd_source=RN&showType=share',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221109-shijianchen-img-4.jpg',
            dec: '回顾澳门|这样的澳门让你去一次爱一次',
            desc: '其实细数澳门我也去过五六次了，每次去都会有不同的感受，都有不一样的新鲜感。',
            linkId:
              'https://touch.travel.qunar.com/youji/7722467?bd_source=RN&showType=share',
          },
        ],
      ],
      list: [
        {
          img:
            'https://source.qunarzz.com/site/images/wns/20230121-shijianchen-img1.jpeg',
          txt: '新马路任我行步行区计划',
          link: 'https://mp.weixin.qq.com/s/EdbG28vNh7beGoXoKsU44Q',
          detail: '今年春节，由澳门多个政府部门联合举办，六大旅游综合体共同支持打造的创新盛大活动 “新马路任我行——步行区试行计划”蓄势待发，将于1月22日（年初一）中午12时至24 日（年初三）晚上10时及2月4日（正月十四）中午12时至5日（正月十五）晚上10 时举行。 是次计划的步行区域位于海边新街至龙嵩正街的新马路地段（亚美打利庇卢大马路），丰富精彩活动将在这里惊喜亮相，与大家欢度新春佳节。',
          linkId:
            'https://touch.travel.qunar.com/h5/topic/comment/31972113?showType=share&bd_source=topic_comment',
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-1.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '2023年度农历春节年宵市场',
          detail: `2023年度农历春节年宵市场<br/>时间： 1月14日至1月22日<br/>春节前夕，塔石广场设有年宵市场，各款贺年礼品、应节装饰以及寓意喜庆吉祥的年花应有尽有，现场亦设特色饮食摊位，满足游人吃喝玩乐的需要。 临近农历新年，与亲朋好友一同「逛年宵」，感受浓厚的节日喜庆气氛。`,
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-2.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '新春爆竹、烟花及火箭燃放活动',
          detail: `新春爆竹、烟花及火箭燃放活动<br/>时间：1月21日至26日<br/>「放鞭炮、燃烟花」是华人过年传统习俗。 每逢新年，澳门半岛及凼仔的两处指定地点会售卖各式烟花、爆竹及火箭，让大家在阵阵爆竹声中辞旧迎新！`,
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-3.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '庆祝农历新年烟花表演',
          detail: `庆祝农历新年烟花表演 <br/>时间：1月24日及28日晚上9时45分，2月5日晚上9时地点：澳门旅游塔对出海面<br/>大年初三、初七及元宵佳节晚上，璀璨夺目的烟花在夜幕中交织绽放，打造多彩绚丽的视觉盛宴，而在烟花映照下的澳门，亦展现出欣欣向荣的美好景象。 如此良辰美景，你岂能错过。
`,
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-4.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '2023年农历新年花车汇演',
          detail: `2023年农历新年花车汇演<br/>时间1月24日及28日<br/>每年一度的花车汇演再次与市民及旅客见面。 多辆美轮美奂的花车，联同本地及内地表演队伍上演文艺表演，沿途为观众载歌载舞，并送上祝福，营造难忘的春节盛会。 汇演结束后，光彩夺目的花车分别于澳门科学馆海堤及塔石广场展出，让你近距离欣赏花车的精巧布置。
`,
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-5.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '2023农历新年庆祝活动─龙腾舞跃贺新春',
          detail: `2023农历新年庆祝活动─龙腾舞跃贺新春<br/>时间： 1月22日及23日 <br/>澳门农历新年庆祝活动多姿多彩，节日气氛浓厚。 大年初一，寓意生龙活虎的238米大金龙在瑞狮的伴随下穿梭澳门多个地点，向观众呈献龙狮表演及拜年。 新春期间，财神爷、金童玉女、福禄寿、兔生肖、澳门旅游吉祥物「麦麦」等在澳门各区向游人派发「金元宝」，精彩的舞蹈表演亦定点上演，为节日增添更多欢乐气氛。
`,
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20230110-shijianchen-img-6.png',
          link: 'https://whatson.macaotourism.gov.mo/information.php?rid=913',
          txt: '2022幻彩耀濠江灯饰装置',
          detail: `2022幻彩耀濠江灯饰装置<br/>时间：12月9日-1月31日<br/>澳门光影节更为这个冬日天上暖意，编织梦幻光影乐章，记得手机拿起来，各种拍拍拍，放到朋友圈炫一下！`,
        },
      ],
    };
  },
  mounted() {
    // let imgsstr = localStorage.getItem(this.getKey());
    // if (imgsstr) {
    //   this.imgs = JSON.parse(imgsstr);
    // }
  },
  methods: {
    showDetail(item) {
      if (!item.detail) return;
      detailDialog({
        item: item,
      });
    },
    jumpTo() {
      if (window.hysdk.sniff.scheme) {
        window.location.href =
          window.hysdk.sniff.scheme +
          '://hy?url=https%3A%2F%2Fm.flight.qunar.com%2Fshark%2Factive%2Ff0da9f5f2c07aeadef127dec0fb21f2f%3Fbd_source%3Dzthd_dapengche%26processCode%3DcommonCreateBargainProcess%26packageCode%3Dmacau_expansion_voucher_2023%26activityType%3Dbargain_common%26activityCode%3Dmacau_expansion_voucher_2023%0A%0A';
      } else {
        window.location.href =
          'https://m.flight.qunar.com/shark/active/f0da9f5f2c07aeadef127dec0fb21f2f?bd_source=zthd_dapengche&processCode=commonCreateBargainProcess&packageCode=macau_expansion_voucher_2023&activityType=bargain_common&activityCode=macau_expansion_voucher_2023';
      }
    },
    getKey() {
      let _date = +new Date();
      if (_date > +new Date('2022/6/29 00:00:00')) {
        return 'zhejiangsonsume/imgs/new/7';
      } else {
        return 'zhejiangsonsume/imgs/new/6';
      }
    },
    jumpTo() {
      if (hysdk.sniff.scheme) {
        window.location.href =
          window.hysdk.sniff.scheme +
          '://hy?url=https%3A%2F%2Fm.flight.qunar.com%2Fshark%2Factive%2Ff0da9f5f2c07aeadef127dec0fb21f2f%3Fbd_source%3Dzthd_dapengche%26processCode%3DcommonCreateBargainProcess%26packageCode%3Dmacau_expansion_voucher_2023%26activityType%3Dbargain_common%26activityCode%3Dmacau_expansion_voucher_2023%0A%0A';
      } else {
        ruleDialog({});
      }
    },
    toggle(index) {
      this.current = index;
      let boxList = ['step1', 'step2', 'step3'];
      window.scrollTo(0, parseInt($('#' + boxList[index]).offset().top - 50));
    },
    showRule() {
      ruleDialog({});
    },
    jump(item, index) {
      location.href = item.link;
    },
  },
};
</script>

<style  lang='less' scoped='true'>
@font-face {
  font-family: 'newFont';
  src: url('./fzpw.ttf');
}
#macau {
  background: #ff7a4c;
}
.content {
  background: #ff7a4c;
}
.cardList {
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-bottom: 21px;
  position: relative;
  .card {
    position: relative;
    .card_icon {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
    }
  }
  img {
    margin-bottom: 8px;
  }
}
img {
  display: block;
}
.boxList {
  padding-left: 15px;
  padding-right: 15px;
}
.tit {
  width: 280px;
  margin: 0 auto;
  margin-bottom: 18px;
}
.tit2 {
  width: 300px;
  margin: 18px auto;
}
.card-fluid {
  width: 340px;
  padding-top: 18px;
  padding-bottom: 18px;
  background: #92cbd5;
  border: 2px solid #ffffff;
  border-radius: 6px;
  margin: 0 auto;
  &:before,
  &:after {
    content: '';
    display: block;
    clear: both;
  }
}
.card-box {
  display: inline-flex;
  margin: 0 28px;
  float: left;
  width: 284px;
  .card-it {
    width: 85px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-sizing: border-box;
    float: left;
  }
  &:first-child {
    .card-it {
      &:first-child {
        background: #1e6e53;
        // border: 2px solid #ffffff;
      }
      &:nth-child(2) {
        background: #d85754;
        width: 95px;
        margin-left: 10px;
        margin-right: 10px;
      }
      &:nth-child(3) {
        background: #349fc9;
      }
    }
  }
  &:nth-child(2) {
    margin-top: 20px;
    .card-it {
      &:first-child {
        background: #fbb11a;
        margin-right: 10px;
      }
      &:nth-child(2) {
        background: #6b5497;
        width: 95px;
      }
    }
  }
}
.intro {
  background: url(https://source.qunarzz.com/site/images/wns/20220830-shijianchen-intro.png)
    no-repeat;
  background-size: 100% auto;
  height: 316px;
  width: 340px;
  margin: 0 auto;
  text-indent: 20px;
  text-align: left;
  color: #fff;
  padding-top: 80px;
  font-size: 12px;
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
}
.swipeWrapper {
  height: 272px;
  margin: 0 auto;
  margin-top: 16px;
  width: 345px;
  /deep/ .mint-swipe-indicators {
    .mint-swipe-indicator {
      opacity: 1;
      background-color: #fff;
      &.is-active {
        background-color: #fb9774;
      }
    }
  }
  .swipe-tp {
    height: 22px;
    overflow-y: hidden;
  }
  .img-box {
    height: 240px;
    border-radius: 6px;
    img {
      height: 240px;
      width: 100%;
    }
    overflow: hidden;
  }
  .swipe-box {
    background: url(https://source.qunarzz.com/site/images/wns/20220830-shijianchen-card-btm.png)
      no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding-left: 10px;
    height: 422px;
    position: relative;
    &:after {
      content: '';
      background: url(https://source.qunarzz.com/site/images/wns/20220830-shijianchen-swipe.jpg)
        no-repeat;
      background-size: 100% auto;
      height: 25px;
      position: absolute;
      width: 150px;
      left: 50%;
      bottom: -4px;
      transform: translate(-50%, -50%);
    }
    .swipe-tit1,
    .swipe-tit2,
    .swipe-tit3 {
      height: 18px;
      margin-left: 15px;
    }
    .swipe-cont {
      width: 330px;
      height: 219px;
      margin-top: 10px;
      margin-bottom: 10px;
      border: 1px solid #555;
      overflow: hidden;
      border-radius: 8px;
    }
    .swipe-bottom {
      width: 330px;
      background: #e9b94e;
      border: 1px solid #1a1a1a;
      border-radius: 6px;
      padding: 8px 5px;
      font-size: 12px;
      text-align: left;
    }
  }
}
.box {
  width: calc(100% - 20px);
  margin: 0 auto;
  background: linear-gradient(0deg, #84b1fa 0%, #71a6f6 100%);
  border-radius: 20px;
  padding-top: 10px;
}
video {
  width: 332px;
  height: 217px;
}
#banner {
  position: relative;
}
.swiper2 {
  height: 180px;
  width: 340px;
  margin: 0 auto;
  margin-top: 10px;
  /deep/ .mint-swipe-indicators {
    .mint-swipe-indicator {
      width: 6px;
      height: 6px;
      background: #aba9a9;
      border: 2px solid #ffffff;
      border-radius: 50%;
      opacity: 1;
    }
    .mint-swipe-indicator.is-active {
      width: 6px;
      height: 6px;
      background: #349fc9;
      border: 2px solid #ffffff;
      border-radius: 50%;
    }
  }
}
.ruleBtn {
  position: absolute;
  right: 10px;
  top: 370px;
  width: 66px;
  height: 23px;
  background: rgba(61, 61, 61, 0.54);
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tit {
  margin: 8px auto;
}
.text {
  padding: 15px;
  padding-top: 0;
  color: #fff;
  text-align: left;
  overflow-y: auto;
}
.line_head {
  width: calc(100% - 20px);
  margin: 0 auto 20px;
}
.line_item {
  width: calc(100% - 20px);
  background: #ffffff;
  border-radius: 10px;
  padding: 8px;
  box-sizing: border-box;
  margin: 0 auto;
  display: block;
  text-decoration: none;
  color: #333;
  margin-top: 10px;
  .line_tit {
    height: 32px;
    margin-bottom: 10px;
    line-height: 16px;
  }
  .tag {
    width: 55px;
    height: 18px;
    color: #007cff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 11px;
    background: linear-gradient(270deg, #faffff 0%, #d2dcff 100%);
    border-radius: 9px 0px 0px 9px;
  }
  .des {
    font-size: 11px;
    color: #666;
  }
  .price {
    color: #ff2f00;
    font-size: 18px;
    &:before {
      content: '￥';
      font-size: 9px;
      position: relative;
    }
    &:after {
      content: '起';
      font-size: 9px;
      position: relative;
    }
  }
  .line_item_rt_btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .btn {
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(-54deg, #ffaf61 0%, #f719a1 100%);
    border-radius: 11px;
    font-size: 11px;
    color: #fff;
    padding-left: 8px;
    padding-right: 8px;
  }
  .line_item_lf {
    float: left;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 120px;
      height: 144px;
    }
  }
  .line_item_rt {
    height: 144px;
    width: calc(100% - 130px);
    padding-top: 10px;
    box-sizing: border-box;
    text-align: left;
    float: right;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.lookMore {
  width: 348px;
  height: 34px;
  background: #fffdfb;
  border-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 18px;
  color: #4b4b4b;
  font-size: 15px;
  text-decoration: none;
}
* {
  box-sizing: border-box;
}
#note {
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 10px;

  background: linear-gradient(0deg, #008a63 0%, #00d0a4 95%);
  margin-bottom: 42px;
}
a {
  text-decoration: none;
}
.note_it {
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  display: block;
  text-decoration: none;
  color: #999;
  border-radius: 5px;
  margin-bottom: 11px;
  .note_img {
    float: left;
    img {
      width: 123px;
      height: 86px;
    }
  }
  .note_cont {
    padding: 10px;
    float: left;
    box-sizing: border-box;
    width: calc(100% - 123px);
    text-align: left;
    height: 85px;
  }
  .note_tit {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #747474;
    line-height: 18px;
    margin-bottom: 6px;
    height: 18px;
    -webkit-line-clamp: 1;
  }
  .note_text {
    color: #747474;
    margin-bottom: 8px;
    font-size: 9px;
    height: 24px;
    line-height: 12px;
  }
  .note_foot {
    text-align: right;
    font-size: 11px;
    color: #747474;
  }
}
.contentActive {
  position: relative;
  height: 600px;
  overflow: hidden;
  .box2331 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .discount {
    width: 365px;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
  }
  .tabs {
    width: 306px;
    height: 35px;
    margin-top: 87px;
    position: relative;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    .tab {
      width: 99px;
      height: 33px;
      float: left;
      margin-right: 3px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .step1 {
    width: 360px;
    height: 117px;
    display: inline-block;
    position: relative;
    z-index: 2;
    margin-top: 65px;
  }
  .step2 {
    width: 360px;
    height: 117px;
    display: inline-block;
    position: relative;
    z-index: 2;
    margin-top: 47px;
  }
  .step3 {
    width: 360px;
    height: 117px;
    display: inline-block;
    position: relative;
    z-index: 2;
  }
}
.bolang {
  min-width: 120px;
  padding-left: 5px;
  padding-right: 5px;
  height: 32px;
  background: url(https://source.qunarzz.com/site/images/wns/20221109-shijianchen-bolang.png)
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  font-family: 'newFont';
  justify-content: center;
  color: #fff;
  font-size: 12px;
}
.swiper {
  height: 200px;
}
.bottom {
  height: 393px;
  overflow-y: hidden;
  position: relative;
  z-index: 2;
}
</style>
